<template>
  <div class="">
    <div class="row align-items-center">
      <div class="col-xl-4">
        <search-field
            :markers="markers"
            v-on:clickmarker="followMarker"
            placeholder="CITY, ADDRESS"
        ></search-field>
      </div>
      <div class="col-xl-8">
        <div class="legends">
          <div class="row">
            <div
                class="col-6 col-md-3 item category-element"
                :class="{'js-active': activeCategory === category}"
                v-for="category in partnerCategories"
                v-bind:key="category.label"
                :category="category"
                @click="() => filterMarkers(category)"
            >
              <img :src="category.icon" alt="Marker"/>
              <span
              ><small>{{ category.label }}</small></span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <GMapMap
        :center="center"
        :zoom="zoom"
        :options="options"
        class="gmap"
        map-type-id="roadmap"
        style="height: 800px"
        ref="GoogleMap"
    >
      <GMapCluster
          :minimumClusterSize="3"
          :zoomOnClick="true"
          :imagePath="'/fileadmin/VendorMap/Cluster-'"
          :imageExtension="'svg'"
          :style="clusterStyle"
          ref="GoogleMapCluster"
      >
        <GMapMarker
            :key="index"
            v-for="(m, index) in visibleMarkers"
            :position="m.position"
            :icon="m.icon"
            :clickable="true"
            :draggable="false"
            @click="() => setOpenedMarker(m)"
        >
          <GMapInfoWindow
              :closeclick="true"
              @closeclick="setOpenedMarker({})"
              :opened="openedMarker === m"
          >
            <div class="marker-infos">
              <h4>{{ m.name }}</h4>
              <div>{{ m.place }}, {{ m.street }} {{ m.streetnumber }}</div>
              <hr/>
              <div>
                <p>{{ m.text }}</p>
                <div>
                  {{ m.email }} - <a :href="m.web" target="_blank">{{ m.web }}</a>
                </div>
              </div>
            </div>
          </GMapInfoWindow>
        </GMapMarker>
      </GMapCluster>
    </GMapMap>
  </div>
</template>

<script>
import mapStyle from "@/data/map-style.json";
import SearchField from "@/components/SearchField";

const json = JSON.parse(document.querySelector("#vendormap-app").dataset.json);

export default {
  name: "MapComponent",
  components: {SearchField},
  data() {
    return {
      markers: [],
      partnerCategories: json.categories,
      center: {lat: 51.250786, lng: 20.471852},
      options: {
        styles: mapStyle,
        minZoom: 3,
      },
      zoom: 3,
      activeCategory: {},
      openedMarker: {},
      visibleMarkers: [],
      clusterStyle: [
        {
          textSize: 14,
          fontWeight: "bold",
          url: json.categories[0].icon,
          backgroundPosition: "-40px 0",
          className: "marker",
        },
      ],
    };
  },
  created() {
    const self = this;
    this.partnerCategories.forEach((cat) => {
      cat.locations.forEach((location) => {
        location.position = {
          lat: parseFloat(location.lat),
          lng: parseFloat(location.long),
        };
        location.icon = cat.icon;
        location.catagory = cat.label;
        location.opened = false;
        self.markers.push(location);
        self.visibleMarkers.push(location);
      });
    });
  },
  methods: {
    followMarker(marker) {
      this.center = marker.position;
      this.zoom = 10 + Math.random();
    },
    setOpenedMarker(marker) {
      this.openedMarker = marker;
    },
    filterMarkers(category) {
      let activeCategory = this.activeCategory;
      if (this.activeCategory !== category) {
        this.activeCategory = category;
      } else {
        this.activeCategory = {};
      }

      let categoryElements = document.querySelectorAll('.categoryElements');
      for (let i = 0; i < categoryElements.length; i++) {
        categoryElements[i].className = "col-6 col-md-3 item category-element";
      }

      this.visibleMarkers = [];
      this.markers.forEach((marker) => {
        if (activeCategory !== category) {
          if (category.locations.includes(marker)) {
            this.visibleMarkers.push(marker);
          }
        } else {
          this.visibleMarkers.push(marker);
        }
      });
    },
    focusLocation(location) {
      this.center.lat = parseInt(location.lat);
      this.center.lng = parseInt(location.lon);
      this.zoom = 7.5;
      // Marker neu zeichnen
      const self = this;
      setTimeout(function() {
        self.visibleMarkers = [];
        self.activeCategory = [];
        self.markers.forEach((marker) => {
          self.visibleMarkers.push(marker);
        });
      }, 20);
    }
  },
};
</script>

<style scoped>

.legends .item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.legends .item span {
  margin-left: 6px;
  text-align: left;
}
.legends .item small {
    line-height: 1.1;
    display: block;
}

.marker-infos {
  color: #20282b;
}

.marker-infos a {
  color: #0081b3;
  text-decoration: underline;
}

.gmap {
  height: 800px;
  margin-top: 25px;
}
#content section .gmap img {
  border-radius: 0;
}

@media screen and (max-width: 991.98px) {
  .legends .item {
    margin-top: 10px;
  }

  .legends .item img {
    width: 40px;
  }
}
</style>
